import { Stack } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import RecipeCard from '../components/RecipeCard';
import { useGetRequestUrl } from '../hooks/useGetRequestUrl';

export default function SavdRecipe() {
  const requestUrl = useGetRequestUrl();
  const [savedRecipes, setSavedRecipes] = useState([]);
  const { id } = useParams();
  console.log(id);
  useEffect(() => {
    const fetchRecipes = async () => {
      const response = await axios.get(
        `${requestUrl}/recipe/savedRecipes/${id}`,
        { withCredentials: false }
      );
      console.log(response.data);
      setSavedRecipes(response.data);
    };
    fetchRecipes();
  }, [id]);

  return (
    <Stack
      ml={{ xs: '0px', sm: '0px', md: '88px', lg: '88px' }}
      mr={{ xs: '0px', sm: '0px', md: '88px', lg: '88px' }}
      pb="40px"
      justifyContent="center"
    >
      <Stack
        direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
        justifyContent={{
          xs: 'center',
          sm: 'center',
          md: 'flex-start',
          lg: 'flex-start',
        }}
        flexWrap="wrap"
        alignItems="center"
        gap={2}
        mt={{ xs: '10px', sm: '10px', md: '20px', lg: '60px' }}
      >
        {savedRecipes.map((savedRecipe) => (
          <RecipeCard recipe={savedRecipe} key={savedRecipe._id} />
        ))}
      </Stack>
    </Stack>
  );
}
